import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=83c7620a&scoped=true&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"
import style0 from "./Create.vue?vue&type=style&index=0&id=83c7620a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c7620a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83c7620a')) {
      api.createRecord('83c7620a', component.options)
    } else {
      api.reload('83c7620a', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=83c7620a&scoped=true&", function () {
      api.rerender('83c7620a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/product/Create.vue"
export default component.exports